import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=556fb62e&"
import script from "./PaymentDescription.vue?vue&type=script&lang=js&"
export * from "./PaymentDescription.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports